import type { UIMessage } from "ai";

/**
 * Whether the tutor's reply changed which sections of a course are recommended to the learner, so the course page should reload them
 * @param {UIMessage} message - The tutor's finished reply
 * @returns {boolean} True when it holds a finished `recommendSections` call
 */
export const madeStudyRecommendation = (message: UIMessage): boolean =>
	(message.parts ?? []).some(
		(part) =>
			part.type === "tool-recommendSections" &&
			"state" in part &&
			part.state === "output-available",
	);
